import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    // Small delay to ensure the DOM is fully ready and avoid conflicts
    this.timeout = setTimeout(() => this.open(), 100);
  }

  disconnect() {
    clearTimeout(this.timeout);
    this.close();
  }

  open() {
    if (!this.element) return;

    // Add Bootstrap classes to show the modal
    this.element.classList.add("show");
    this.element.style.display = "block";
    this.element.setAttribute("aria-modal", "true");
    this.element.setAttribute("role", "dialog");

    // Prevent body scrolling
    document.body.classList.add("modal-open");

    // Create and append the backdrop if it doesn't exist
    if (!document.querySelector(".modal-backdrop")) {
      const backdrop = document.createElement("div");
      backdrop.className = "modal-backdrop fade show";
      document.body.appendChild(backdrop);
    }
  }

  close() {
    if (!this.element) return;

    // Remove Bootstrap classes to hide the modal
    this.element.classList.remove("show");
    this.element.style.display = "none";
    this.element.removeAttribute("aria-modal");
    this.element.removeAttribute("role");

    // Re-enable body scrolling
    document.body.classList.remove("modal-open");

    // Remove the backdrop
    const backdrop = document.querySelector(".modal-backdrop");
    if (backdrop) {
      backdrop.remove();
    }
  }
}
